import { AfterViewChecked, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { TegelModule } from '@scania/tegel-angular-17';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-modal',
  imports: [
    TegelModule,
    CommonModule
  ],
  templateUrl: './modal.component.html',
  styleUrl: './modal.component.scss',
})

export class ModalComponent {
  @Input() visible = false;

  @ViewChild('triggerBtn', { static: false, read: ElementRef }) triggerBtn!: ElementRef;

  modalTitle = ''
  
  constructor() {
  }

  open() {
    this.triggerBtn.nativeElement.click();
  }
}
